interface ServiceItem {
  icon: string;
  title: string;
  subtitle: string;
  description: string;
}

const services: ServiceItem[] = [
  {
    icon: 'ri-google-fill',
    title: 'Google Ads Yönetimi',
    subtitle: 'Arama Niyetine Göre',
    description:
      'Arama ağı, Performance Max, YouTube ve diğer Google reklam modellerini markanın ticari hedefleri doğrultusunda kurguluyoruz. Aranan kelimeye değil, arama niyetine bakıyoruz.',
  },
  {
    icon: 'ri-meta-fill',
    title: 'Meta Ads Yönetimi',
    subtitle: 'Kreatif + Veri Birlikte',
    description:
      'Instagram ve Facebook reklamlarını yalnızca hedef kitle seçerek yönetmiyoruz. Kreatif, mesaj, teklif, hedefleme ve kullanıcı davranışını birlikte test ediyoruz.',
  },
  {
    icon: 'ri-line-chart-fill',
    title: 'CRO',
    subtitle: 'Dönüşüm Oranı Optimizasyonu',
    description:
      'Trafiği artırmadan önce mevcut trafiğin neden dönüşmediğine bakıyoruz. Landing page, teklif yapısı, kullanıcı deneyimi, güven unsurları ve aksiyon noktalarını analiz ediyoruz.',
  },
  {
    icon: 'ri-bar-chart-box-fill',
    title: 'Funnel & Analytics',
    subtitle: 'Tam Huni Analizi',
    description:
      'Kullanıcı reklamı gördükten sonra ne yapıyor? Nereden geliyor? Nerede çıkıyor? Nerede karar veriyor? Performans pazarlaması bizim için bu soruların cevabıyla başlıyor.',
  },
];

export default function ServiceGrid() {
  return (
    <div className="grid md:grid-cols-2 gap-4 md:gap-5">
      {services.map((s, i) => (
        <div
          key={i}
          className="glass-card-hover rounded-2xl p-6 md:p-8 group relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 w-32 h-32 bg-primary-500/5 rounded-bl-full -mr-8 -mt-8 transition-all duration-500 group-hover:bg-primary-500/10 group-hover:scale-150" />
          <div className="relative z-10">
            <div className="w-12 h-12 bg-background-200 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary-500/15 transition-colors duration-300">
              <i className={`${s.icon} text-xl text-primary-500`} />
            </div>
            <p className="text-xs font-bold text-primary-500 tracking-widest uppercase mb-2">
              {s.subtitle}
            </p>
            <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-3">
              {s.title}
            </h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {s.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}